import { post } from './http'

// 获取课表信息 
export const getScheduleByCal = data => post('/api/meas/admin/teach/courseperiod/getScheduleByCal', data)

// 获取统计数据 
export const getAdminSummaryInfo = data => post('/api/meas/admin/teach/getAdminSummaryInfo', data)